<div
  class="no-chart-data d-flex h-100 justify-content-center align-items-center {{ innerDivClassName }}"
  data-category="figures"
>
  <figure class="figure">
    <img src="/assets/images/svg_ico/kaliuk.svg" alt="kaliuk" class="kaliuk kaliuk-big" />
    <figcaption class="figure-caption">
      <h4 i18n="@@laoding-error.pageSectionIsNotAvailable">
        This section is not available right now. Try again later.
      </h4>
    </figcaption>
  </figure>
</div>
